import classNames from 'classnames';
import {
  FlexContainer,
  PartialWidthContainer,
  PropertyBlock,
  InfoMessageBlock,
  AccountVerificationStatus,
  StatCarousel,
  SubscriptionStatusProperties,
  Button,
  NoSubscriptionInfo,
  GreetingText,
  Txt,
  LoadingPlaceholder,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useProperties, useSubscription } from 'state';
import { SubscriptionStatusTypes } from 'config/types';
import styles from './PropertiesListScreen.module.scss';

/**
 * PropertiesListScreen
 *
 * @return {JSX.Element}
 */
const PropertiesListScreen = ({ className }) => {
  const navigate = useNavigate();
  const properties = useProperties();
  const subscription = useSubscription();
  const [isShownNoSub, setIsShownNoSub] = useState(false);

  const noSubscription =
    subscription.data.status !== SubscriptionStatusTypes.active;
  const noProperties = properties.data.length === 0;
  const blockActions = noSubscription && !noProperties;

  const handleCloseNoSub = () => setIsShownNoSub(false);

  const handleAction = () => {
    return blockActions ? setIsShownNoSub(true) : navigate('new');
  };

  const handlePropertyClick = (id) => () => navigate(id);

  return (
    <PartialWidthContainer
      className={classNames(
        styles.PropertiesListScreen,
        className,
        `${PropertiesListScreen.displayName}`
      )}
      small
      column
      gap
      flex
    >
      <Helmet title="Properties" />
      <FlexContainer gap>
        <FlexContainer overflow>
          <StatCarousel />
        </FlexContainer>
        <Button success onClick={handleAction}>
          Add a property
        </Button>
      </FlexContainer>
      <Txt>
        <GreetingText />
      </Txt>
      <AccountVerificationStatus />
      <SubscriptionStatusProperties />
      {properties.data.length ? (
        <FlexContainer className={styles.Body} column gap>
          {/*<FlexContainer spaceBetween alignCenter>*/}
          {/*  <TxtTitle xxxx bold>*/}
          {/*    Properties*/}
          {/*  </TxtTitle>*/}
          {/*  /!*<Button>Edit</Button>*!/*/}
          {/*</FlexContainer>*/}
          <FlexContainer wrap gap className={styles.PropertiesList}>
            {properties.data.map(({ isInitialized, id, data: p }) =>
              isInitialized ? (
                <PropertyBlock
                  key={id}
                  bathroomCount={p.bathroomCount}
                  bedroomCount={p.bedroomCount}
                  imageUrls={p.imageUrls}
                  title={p.address.postcode}
                  subTitle={p.address.name}
                  onClick={handlePropertyClick(p.propertyUid)}
                  disableSlider
                />
              ) : (
                <LoadingPlaceholder spinner />
              )
            )}
          </FlexContainer>
        </FlexContainer>
      ) : (
        <InfoMessageBlock
          title="Welcome Propa Landlord  🎉"
          description="Get started by adding a property using the button above."
        />
      )}
      {isShownNoSub ? <NoSubscriptionInfo onClose={handleCloseNoSub} /> : null}
    </PartialWidthContainer>
  );
};

PropertiesListScreen.displayName = 'PropertiesListScreen';

export default observer(PropertiesListScreen);
